import React from "react";
import styled from "@emotion/styled";
import Link from "next/link";

import Button from "shared/components/Button";
import VideoModal from "shared/components/video-modal";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";

function VideosThumbnail(props: IVideosThumbnail) {
  const { url, videoId, thumbnail } = props;
  const translation = useTranslations("join.motivation");

  let imgSrc;

  if (thumbnail) {
    imgSrc = thumbnail;
  } else {
    imgSrc = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }

  return (
    <VideoModal url={videoId}>
      <div style={{ cursor: "pointer" }}>
        <ThumbnailWrapper>
          <Thumbnail src={imgSrc} />
        </ThumbnailWrapper>
        <VideoText>{translation("seeVideo")}</VideoText>
      </div>
    </VideoModal>
  );
}

const videosItems = [
  {
    url: "https://www.youtube.com/watch?v=dUSqN6Lb1Wk",
    videoId: "dUSqN6Lb1Wk",
    // thumbnail: "/images/remaxrd_agent1.png",
  },
  // {
  //   url: "https://www.youtube.com/watch?v=U8nRrK1WiwE",
  //   videoId: "U8nRrK1WiwE",
  //   // thumbnail: "/images/remaxrd_agent2.png",
  // },
];

function Motivation() {
  const translation = useTranslations("join.motivation");
  return (
    <Wrapper>
      <MotivationContainer className="container">
        <MotivationVideos>
          {videosItems.map((item, index) => (
            <article key={index}>
              <VideosThumbnail {...item} />
            </article>
          ))}
        </MotivationVideos>
        <MotivationDescription>
          <MotivationTitle>{translation("title")}</MotivationTitle>
          <MotivationText>{translation("description")}</MotivationText>
          <MotivationText>{translation("info")}</MotivationText>
          <Link href={CPagesPath.es.frequent_questions} passHref>
            <MotivationButton disableRipple component="a">
              {translation("faq")}
            </MotivationButton>
          </Link>
        </MotivationDescription>
      </MotivationContainer>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  background-color: #fff;
  border-radius: 200px 0px 0px 0px;
  padding: 85px 0;

  @media screen and (max-width: 991px) {
    border-radius: 150px 0px 0px 0px;
  }

  @media screen and (max-width: 767px) {
    border-radius: 50px 0px 0px 0px;
  }
`;

const MotivationContainer = styled.div`
  display: flex;
  justify-content: space-around;
  @media screen and (max-width: 991px) {
    flex-direction: column;
  }
`;

const MotivationDescription = styled.section`
  max-width: 600px;
  padding: 0px 10px;
  align-self: center;
`;

const MotivationTitle = styled.h2`
  max-width: 300px;
  font-size: 1.438rem;
  font-weight: 700;
  text-align: left;
  text-transform: none;
  margin-bottom: 24px;
  color: var(--color-blue-main);
`;

const MotivationText = styled.p`
  font-size: 0.938rem;
  font-weight: 700;
  line-height: 18px;
  color: #99999b;
  margin-bottom: 20px;
`;

const MotivationButton = styled(Button)`
  margin-top: 75px;
  height: 40px;
  color: var(--white);

  @media screen and (max-width: 991px) {
    display: block;
    margin: 0 auto;
    margin-top: 75px;
  }

  & > a {
    color: inherit;
  }

  &:focus-visible {
    outline: Highlight auto 1px;
    outline: -webkit-focus-ring-color auto 1px;
  }
`;

const MotivationVideos = styled.div`
  & > :nth-child(1) {
    margin-bottom: 45px;
  }
  @media screen and (max-width: 991px) {
    display: flex;
    justify-content: space-evenly;
  }
  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
  }
`;

const VideoLink = styled.a`
  text-decoration: "none";
  color: var(--color-blue-main);

  &:active {
    text-decoration: inherit;
  }

  &:visited {
    text-decoration: inherit;
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
`;

const ThumbnailWrapper = styled.div`
  width: 260px;
  height: 170px;
  border-radius: 20px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 15px;
  overflow: hidden;
  @media screen and (max-width: 480px) {
    width: 100%;
    max-width: 380px;
    margin: auto;
    height: auto;
  }
`;

const VideoText = styled.p`
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  color: var(--color-blue-main);
  cursor: pointer;
`;

interface IVideosThumbnail {
  url: string;
  videoId: string;
  thumbnail?: string;
}

export default Motivation;
